import { FC, useMemo } from 'react'
import styled from '@emotion/styled'

const Container = styled('div')(({ theme }) => ({
  fontSize: theme.fontSize.small,
  color: theme.colors.text.primary,
}))

export const ChatBoxMessageTime: FC<{ date: Date }> = ({ date }) => {
  const time = useMemo<string>(() => {
    return date.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    })
  }, [date])

  return <Container>{time}</Container>
}
